// extracted by mini-css-extract-plugin
module.exports = {"chartstyles":"NewLineChart_chartstyles__5yxp3"};